import React, { useState, useEffect, useCallback } from "react";
import Countdown from "react-countdown";
import { Box, Button, Text } from "@chakra-ui/react";
import moment from "moment";
import { toast } from "react-toastify";
import { pauseSLA } from "../services/axios";

function RequestSLA({ loanRequestSLA }) {
  const role = localStorage.getItem("role");
  const [sla, setSla] = useState();
  const [alreadyActioned, setAlreadyAction] = useState(false);
  const [actionedTime, setActionedTime] = useState();

  const getSLAInfo = useCallback(() => {
    const roleMapping = {
      Reporting: {
        received: loanRequestSLA?.sales_received,
        actioned: loanRequestSLA?.sales_actioned,
      },
      "Finance Ops": {
        received: loanRequestSLA?.finance_ops_received,
        actioned: loanRequestSLA?.finance_ops_actioned,
      },
      "Finance Admin": {
        received: loanRequestSLA?.finance_admin_received,
        actioned: loanRequestSLA?.finance_admin_actioned,
      },
      Admin: {
        received: loanRequestSLA?.admin_received,
        actioned: loanRequestSLA?.admin_actioned,
      },
    };

    return roleMapping[role] || roleMapping.Admin;
  }, [loanRequestSLA, role]);

  useEffect(() => {
    const info = getSLAInfo();
    setSla(info.received);
    setAlreadyAction(!!info.actioned);
    setActionedTime(info.actioned);
  }, [getSLAInfo]);

  const targetDate = sla ? new Date(new Date(sla).getTime() + 21600000) : null;

  const pauseSLAHandler = async () => {
    const res = await pauseSLA(loanRequestSLA?.request_id);
    if (res) {
      toast.success("SLA paused successfully");
      window.location.reload();
    }
  };

  return (
    <Box>
      <Box fontWeight="extrabold">
        {sla && !alreadyActioned && (
          <Countdown
            date={targetDate}
            overtime={true}
            style={{
              fontSize: "18px",
              fontFamily: "satoshiBold",
              color: "var(--chakra-colors-brand-500)",
              fontWeight: "600",
            }}
          />
        )}

        {alreadyActioned && (
          <Text color="brand.500" fontSize="14px" fontWeight="600">
            Actioned: {moment(actionedTime).format("DD/MM/YYYY, h:mm:ss a")}
          </Text>
        )}

        {(role === "Reporting" || role === "Finance Ops") &&
          !getSLAInfo().actioned && (
            <Button
              colorScheme="red"
              size="sm"
              ml="4"
              onClick={pauseSLAHandler}
              fontSize="11px"
            >
              PAUSE SLA
            </Button>
          )}
      </Box>
    </Box>
  );
}

export default RequestSLA;
